import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMailList, getTotalUsers } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { Chart, registerables} from 'chart.js';





class bewisetotal extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              mailList: [],
        };

        this.getTotalUsers();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_maili', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

      //this.setHorizontalVerticalChart(databarhorizontal);
    }


    getTotalUsers = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getTotalUsers(ins).then((res) => {
        if (res.status == 1) {
          

                  let MeSeData = {
                  labels: [
                    "Schools",
                    "Preschools",
                    "Tuitions",
                    "After Schools",
                    "Learning Camps",
                    "Community Supports",
                    "Events"
                  ],
                  datasets: [{
                    label: "Users",
                    data: res.data,
                    backgroundColor: ["#669911", "#669911", "#669911","#669911","#669911","#669911","#669911"],
                    hoverBackgroundColor: ["#66A2EB", "#FCCE56","#66A2EB", "#FCCE56","#66A2EB", "#FCCE56","#66A2EB"]
                  }]
                  };

                  let myChart = new Chart(document.getElementById('horizontalVerticalChart'), {
                    type: 'horizontalBar',
                    data: MeSeData,
                    options: {

                      scales: {
                        xAxes: [{
                          ticks: {
                            beginAtZero: true
                          }
                        }]
                      }
                    }
                  });


        } 
      });
    }    


    render() {

        const { mailList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
                    <div class="row  mt-3">
                            <div class="col-xl-12 d-flex grid-margin stretch-card">
                              <div class="card">
                                <div class="card-body">
                                  <div class="d-flex flex-wrap justify-content-between">
                                    <h4 class="card-title mb-3">Reports</h4>
                                  </div>
                                  <div class="row">
                                    <div class="col-6">

                                        <canvas id="horizontalVerticalChart"></canvas>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default bewisetotal;


// WEBPACK FOOTER //
// ./src/components/bewise/bewisetotal.jsx